(function () {
  'use strict';

  /* @ngdoc object
   * @name expurgo
   * @description
   *
   */
  angular
    .module('expurgo', [
      'ui.router',
      'ui.bootstrap.modal',
      'httpServiceV3gModule',
      'ConstantModule',
      'angularMoment',
      'uoModule',
      'uoArvoreNivelModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'AlertasModule',
      'veiculos',
      'pascalprecht.translate'
    ])
    .filter('veiculosFilter', () => {
      return (veiculos, props) => {
        let veiculosFiltrados = [];
        if (angular.isArray(veiculos)) {
          veiculos.forEach((veiculo) => {
            let veiculoMatches = false;

            const keys = Object.keys(props);

            keys.forEach((key) => {
              const parametroDeBusca = props[key].toLowerCase(),
                  keyContemParametroDeBusca = veiculo[key] ? veiculo[key].toLowerCase().includes(parametroDeBusca) : '';
              if (keyContemParametroDeBusca) {
                veiculoMatches = true;
                return;
              }
            });

            if (veiculoMatches) {
              veiculosFiltrados.push(veiculo);
            }
          });
        } else {
          veiculosFiltrados = veiculos;
        }

        return veiculosFiltrados;
      };
    });
}());
